/**
 * Human-friendly name for a document source.
 *
 * Document filenames are frequently opaque identifiers (e.g. NRC ADAMS
 * accession numbers like "ML18045A007.pdf"). When the platform has
 * AI-extracted a real document title we show that instead, falling back to
 * the filename only when no usable title exists.
 */
export const getSourceDisplayName = (
  sdrData: Record<string, any> | undefined | null,
): string | undefined => {
  if (!sdrData) return undefined;
  const title = sdrData.extracted_metadata?.title;
  if (
    typeof title === "string" &&
    title.trim() &&
    title.trim().toLowerCase() !== "unknown"
  ) {
    return title.trim();
  }
  return sdrData.file_name;
};
